import '../css/MembresAdmin.css';
import React, { useEffect, useState } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import * as API from "../services/API";
import Icon from "../util/Icon";
import { Modal, Button } from "react-bootstrap";
import ConfirmModal from "../components/ConfirmModal";
import ErrorModal from "../components/ErrorModal";
import SuccessToast from "../components/SuccessToast";

// import Card from "../components/card";

// Modal Component
const MyModal = ({ onClose,onAdd,member = null,isUpdate, handleResetPassword}) => {
	const [_id, set_id] = useState(member?member._id:null);
	const [username, setUsername] = useState(member?member.username:null);
	const [password, setPassword] = useState(null);
	const [last_name, setLast_name] = useState(member?member.last_name:null);
	const [fonction, setFonction] = useState(member?member.function:null);
	const [first_name, setFirst_name] = useState(member?member.first_name:null);
	const [role, setRole] = useState(member?member.role:1);
	const [lang, setLang] = useState(member?member.lang:"fr");
	const [createdAt] = useState(member?member.createdAt:null);
	const [phone,setPhone] = useState(member?member.phone:null);
	const [updatedAt] = useState(member?member.updatedAt:null);
	const [isDeleted] = useState(member?member.isDeleted:null);
	const [email,setEmail] = useState(member?member.email:null);
	const [errors, setErrors] = useState({});
	const [passwordStrength, setPasswordStrength] = useState(0);
	const [passwordChecks, setPasswordChecks] = useState({});
	const [isPasswordFocused, setIsPasswordFocused] = useState(false);
	const isFormComplete =
		Boolean(username?.trim()) &&
		Boolean(last_name?.trim()) &&
		Boolean(first_name?.trim()) &&
		Boolean(email?.trim()) &&
		(isUpdate || (Boolean(password?.trim()) && passwordStrength === 4));
	const analyzePassword = (value) => {
		const checks = {
			length: value.length >= 8,
			uppercase: /[A-Z]/.test(value),
			lowercase: /[a-z]/.test(value),
			number: /[0-9]/.test(value),
			// special: /[^A-Za-z0-9]/.test(value),
		};

		const score = Object.values(checks).filter(Boolean).length;

		setPasswordChecks(checks);
		setPasswordStrength(score);
	};
	const validate = () => {
		const newErrors = {};

		if (!username || username.trim() === "") {
			newErrors.username = "Le nom d'utilisateur est obligatoire";
		}

		if (!isUpdate && (!password || password.trim() === "")) {
			newErrors.password = "Le mot de passe est obligatoire";
		}
		if (!isUpdate && passwordStrength < 4) {
			newErrors.password = "Mot de passe insuffisamment sécurisé";
		}
		if (!last_name || last_name.trim() === "") {
			newErrors.last_name = "Le nom est obligatoire";
		}

		if (!first_name || first_name.trim() === "") {
			newErrors.first_name = "Le prénom est obligatoire";
		}
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!email || email.trim() === "") {
			newErrors.email = "L'email est obligatoire";
		} else if (!emailRegex.test(email)) {
			newErrors.email = "Format d'email invalide";
		}
		setErrors(newErrors);

		return Object.keys(newErrors).length === 0;
	};
	// const [description, setDescription] = useState("");
	return (
	<Modal
        show={true}
        onHide={onClose}
        size={"lg"}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Création de Membre
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
			<label htmlFor="username">Nom d'utilisateur</label>
			<input
				type={"text" }
				className="form-control m-2"
				id="username"
				value={username}
				onChange={(e)=>setUsername(e.target.value)}
				name="username"
			/>
			{errors.username && (
				<div className="text-danger ms-2">
					{errors.username}
				</div>
			)}
			<label htmlFor="Password">Mot de passe</label>

			<div className="m-2">

			{/* Input + bouton reset */}
			<div className="input-group">
				<input
				type="text"
				className={`form-control ${errors.password ? "is-invalid" : ""}`}
				value={password || ""}
				onChange={(e) => {
					setPassword(e.target.value);
					analyzePassword(e.target.value);
				}}
				onFocus={() => setIsPasswordFocused(true)}
				onBlur={() => setIsPasswordFocused(false)}
				disabled={isUpdate}
				/>

				{isUpdate && (
				<span
					className="input-group-text reset-password-icon"
					onClick={() => handleResetPassword(_id)}
					title="Réinitialiser le mot de passe"
					role="button"
				>
					🔄
				</span>
				)}
			</div>

			{/* Barre + critères EN DESSOUS */}
			{isPasswordFocused && !isUpdate && (
				<div className="mt-2">

				{/* Barre */}
				<div
					style={{
					height: "6px",
					backgroundColor: "#e9ecef",
					borderRadius: "6px",
					overflow: "hidden",
					marginBottom: "8px"
					}}
				>
					<div
					style={{
						width: `${(passwordStrength / 4) * 100}%`,
						height: "100%",
						transition: "all 0.3s ease",
						backgroundColor:
						passwordStrength <= 2
							? "#dc3545"
							: passwordStrength <= 3
							? "#ffc107"
							: "#198754",
					}}
					/>
				</div>

				{/* Critères */}
				<div className="small d-grid gap-1">
					<span className={passwordChecks.length ? "text-success" : "text-muted"}>
					{passwordChecks.length ? "✔" : "•"} 8 caractères minimum
					</span>

					<span className={passwordChecks.uppercase ? "text-success" : "text-muted"}>
					{passwordChecks.uppercase ? "✔" : "•"} 1 majuscule
					</span>

					<span className={passwordChecks.lowercase ? "text-success" : "text-muted"}>
					{passwordChecks.lowercase ? "✔" : "•"} 1 minuscule
					</span>

					<span className={passwordChecks.number ? "text-success" : "text-muted"}>
					{passwordChecks.number ? "✔" : "•"} 1 chiffre
					</span>

					{/* <span className={passwordChecks.special ? "text-success" : "text-muted"}>
					{passwordChecks.special ? "✔" : "•"} 1 caractère spécial
					</span> */}
				</div>

				</div>
			)}

			{errors.password && (
				<div className="text-danger mt-1">
				{errors.password}
				</div>
			)}

			</div>
			<label htmlFor="last_name">Nom</label>
			<textarea 
				type={"text" }
				className="form-control m-2"
				id="last_name"
				rows="1" 
				maxlength="50"
				value={last_name}
				onChange={(e)=>setLast_name(e.target.value)}
				name="last_name"
			/>
			{errors.last_name && (
				<div className="text-danger ms-2">
					{errors.last_name}
				</div>
			)}
			<label htmlFor="first_name">Prénom</label>
			<input
				type={"text" }
				className="form-control m-2"
				id="first_name"
				value={first_name}
				onChange={(e)=>setFirst_name(e.target.value)}
				name="first_name"
			/>
			{errors.first_name && (
				<div className="text-danger ms-2">
					{errors.first_name}
				</div>
			)}
			<label htmlFor="email">Email</label>
			<textarea 
				type={"text" }
				className="form-control m-2"
				id="email"
				rows="1" 
				maxlength="50"
				value={email}
				onChange={(e)=>setEmail(e.target.value)}
				name="email"
			/>
			{errors.email && (
				<div className="text-danger ms-2">
					{errors.email}
				</div>
			)}
			<label htmlFor="Roles">Role</label>
			<select
				name="Roles" 
				className="form-control m-2"
				id="Roles"
				onChange={(e)=>setRole(e.target.value)}
				defaultValue={role}

			>
				<option value="1">Membre</option>
				<option value="2">Admin</option>
			</select>
			<label htmlFor="Phone">Phone</label>
			<input
				type={"text" }
				className="form-control m-2"
				id="Phone"
				value={phone}
				onChange={(e)=>setPhone(e.target.value)}
				name="Phone"
			/>
			<label htmlFor="Fonction">Fonction</label>
			<input
				type={"text" }
				className="form-control m-2"
				id="Fonction"
				value={fonction}
				onChange={(e)=>setFonction(e.target.value)}
				name="Fonction"
			/>
			<label htmlFor="Langage">Langage</label>
			<select
				name="Langage" 
				className="form-control m-2"
				id="Langage"
				onChange={(e)=>setLang(e.target.value)}
				defaultValue={lang}
			>
				<option value="fr">Français</option>
				<option value="en">Anglais</option>
			</select>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Annuler
          </Button>
		  <Button
			variant="primary"
			disabled={!isFormComplete}
			onClick={()=>{if (!validate()) return;onAdd({_id:_id,username:username,password:password,last_name:last_name,first_name:first_name,role:role,function:fonction,lang:lang,createdAt:createdAt,phone:phone,updatedAt:updatedAt,isDeleted:isDeleted,email:email})}}
		  >
            {isUpdate?"Modifier":"Ajouter"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
}	

function MembresAdmin(){
	const [modalOpen, setModalOpen] = useState(null);
	const [confirm, setConfirm] = useState(null);
	const [MembersList, setMembersList] = useState([]);
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);
	useEffect(() => {
		API.getAllMembersRequest(
			(response)=>{
				let sortedData = response.data.sort((a,b)=>{
					const nameA = a.last_name.toUpperCase(); 
  					const nameB = b.last_name.toUpperCase(); 
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					}

					// les noms sont égaux
					return 0;
				})
				setMembersList(sortedData);
			},
			()=>{
			}
			)
		},
		[]
		);
	const addMember = (data) => {API.createMemberRequest(data,()=>{API.getAllMembersRequest((response)=>{setMembersList(response.data);setSuccess("Utilisateur ajoute avec succes.");closeModal();},(data)=>{})},(data)=>{setError(data);})};
	const handleResetPassword = (id) => {API.resetPasswordRequest(id,()=>{},()=>{})};
	const updateMember = (data,member) => {API.updateMemberRequest(data,()=>{setModalOpen(null);API.getAllMembersRequest((response)=>{setMembersList(response.data);},(data)=>{})},(data)=>{})};
	const openAddModal = () => setModalOpen(<MyModal onClose={closeModal} onAdd={addMember}/>);
	const openUpdateModal = (member) => setModalOpen(<MyModal onClose={closeModal} onAdd={(data)=>updateMember(data,member)} member={member} isUpdate={true} handleResetPassword={(id)=>{handleResetPassword(id)}} />);
	const closeModal = () => setModalOpen(null);

		let action = (a)=>(<>
			<Icon  size="xl"
			onClick={() =>
				openUpdateModal(a)
			}
			 icon="pen-to-square" clickable  />
		<Icon  size="xl"
			onClick={(e) =>{
				setConfirm({
					title: "Supprimer la catégorie",
					message: "Cette action est irréversible. Continuer ?",
					onConfirm: () => API.deleteMemberRequest(a._id,()=>{
						API.getAllMembersRequest(
							(response)=>{
								setMembersList(response.data);
							},
							()=>{
							}
							)
						},
						()=>{}
					),
				});
			}
			}
			 icon="trash" clickable  />
		</>);
	return (
  <>
    <div className="min-vh-100 bg-light">
      <HeaderHomeAdmin />

      <div className="container-fluid py-5">
        {/* Titre + action */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="fw-bold text-dark mb-0">
            Liste des membres
          </h1>

          <button
            className="btn btn-primary"
            onClick={openAddModal}
          >
            + Créer un utilisateur
          </button>
        </div>

        {/* Tableau */}
        <div className="card shadow-sm border-0">
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-secondary">
                  <tr>
                    <th className="ps-4">Login</th>
                    <th>Nom</th>
                    <th>Prénom</th>
                    <th>Téléphone</th>
                    <th>Email</th>
					<th>Role</th>
                    <th className="text-center pe-4">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {MembersList && MembersList.length > 0 ? (
                    MembersList.map((member) => (
                      <tr key={member.id}>
                        <td className="ps-4 fw-medium">
                          {member.username}
                        </td>
                        <td>{member.last_name}</td>
                        <td>{member.first_name}</td>
                        <td className="text-muted">
                          {member.phone || "—"}
                        </td>
                        <td className="text-muted">
                          {member.email || "—"}
                        </td>
						<td className="text-muted">
                          {member.role === 1?"Membre":"Admin" || "—"}
                        </td>
                        <td className="text-center pe-4">
                          <div className="d-inline-flex gap-2">
                            {action(member)}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        className="text-center text-muted py-5"
                      >
                        Aucun membre trouvé
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
		<ConfirmModal
			show={!!confirm}
			title={confirm?.title}
			message={confirm?.message}
			onConfirm={confirm?.onConfirm}
			onClose={() => setConfirm(null)}
		/>
		<ErrorModal
			show={!!error}
			message={error}
			onClose={() => setError(null)}
		/>
		<SuccessToast
			show={!!success}
			message={success}
			onClose={() => setSuccess(null)}
		/>
        {modalOpen}
      </div>
    </div>
  </>
);

}


export default MembresAdmin;
